import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ChevronRight, Home } from 'lucide-react'

const ROUTE_LABELS = {
  algorithms: 'Algorithms',
  backtests: 'Backtests',
  charts: 'Charts',
  'ai-signals': 'Market Monitor',
  'market-monitor': 'Market Monitor',
  'trading-history': 'Trading History',
  brokers: 'Brokers',
  analytics: 'Analytics',
  'paper-trading': 'Paper Trading',
  settings: 'Settings',
  profile: 'Profile',
  'contract-rollover': 'Contract Rollover',
  arbitrage: 'Arbitrage',
  journal: 'Journal',
  screener: 'Screener',
  'oi-analysis': 'OI Analysis',
  options: 'Options Builder',
  marketplace: 'Marketplace',
  'code-editor': 'Code Editor',
  assistant: 'x3 Assistant',
  'ai-chat': 'x3 Assistant',
  'backtest-compare': 'Backtest Comparison',
  activity: 'Activity Log',
  status: 'System Status',
  calculators: 'Calculators',
  admin: 'Admin'
}

function Breadcrumbs() {
  const location = useLocation()
  const segments = location.pathname.split('/').filter(Boolean)

  // Don't show breadcrumbs on root/dashboard
  if (segments.length <= 1 && (segments[0] === 'dashboard' || !segments[0])) {
    return null
  }

  // Don't show for single-level routes (no nesting)
  if (segments.length <= 1) {
    return null
  }

  const crumbs = segments.map((segment, index) => {
    const path = '/' + segments.slice(0, index + 1).join('/')
    const label = ROUTE_LABELS[segment] || (segment.startsWith('al-') || segment.startsWith('bt-')
      ? `#${segment.slice(0, 10)}…`
      : segment.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()))
    const isLast = index === segments.length - 1

    return { path, label, isLast }
  })

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-sm text-gray-500 dark:text-gray-400 py-2 px-1">
      <Link to="/" className="hover:text-gray-700 dark:hover:text-gray-200 flex items-center">
        <Home className="w-3.5 h-3.5" />
      </Link>
      {crumbs.map((crumb) => (
        <React.Fragment key={crumb.path}>
          <ChevronRight className="w-3.5 h-3.5 text-gray-400 dark:text-gray-600 flex-shrink-0" />
          {crumb.isLast ? (
            <span className="text-gray-900 dark:text-white font-medium truncate max-w-[200px]" aria-current="page">
              {crumb.label}
            </span>
          ) : (
            <Link to={crumb.path} className="hover:text-gray-700 dark:hover:text-gray-200 truncate max-w-[200px]">
              {crumb.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  )
}

export default Breadcrumbs
